import type { FaireProductEntity } from "../../entity_types/product";

export const p_c2ve9x2uvg: FaireProductEntity = {
  token: "p_c2ve9x2uvg",
  type: "product",
  name: "Maroon Bandana Fringe Crossbody",
  brandToken: "b_5m4wqw135i",
  brandName: "Panache Apparel Co.",
  imageUrl: "https://cdn.faire.com/fastly/7d8e318b8e650f0fc426d96b6484f5ab4dc8c4f8e60ba17f963c2a98d76ad3f8.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/3ac7d6e74c001546e0ba188d4516d59aa9c3a48b6941abd78f85c1254e694891.jpeg",
    "https://cdn.faire.com/fastly/5aa53cd5ecbbac239351b705d181648649008a6274a888b73bac2cbb215b1bc5.jpeg"
  ],
  priceDollars: 37.95,
  description: "A maroon bandana fringe crossbody featuring a classic paisley print, designed with a long crossbody strap and suede leather fringe detailing for a stylish western-inspired look. Roomy interior is perfect for carrying daily essentials while adding a statement touch to any outfit.\n\n14\" W x 10\" H\n\n100% Cotton\n\nMin. Qty: 2",
  tags: [],
  msrpDollars: 94.88,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-10-28T21:05:41.876Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
